module.exports = __webpack_public_path__ + "static/media/iud_info_background.c9b79620.jpg";